import { render, staticRenderFns } from "./CartoesMercadoPago.vue?vue&type=template&id=62e7a64c&scoped=true"
import script from "./CartoesMercadoPago.vue?vue&type=script&lang=js"
export * from "./CartoesMercadoPago.vue?vue&type=script&lang=js"
import style0 from "./CartoesMercadoPago.vue?vue&type=style&index=0&id=62e7a64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7a64c",
  null
  
)

export default component.exports